export const eq = comparator => value => value === comparator;
export const neq = comparator => value => value !== comparator;
